import type { InputRef } from "antd";
import { Select, Space } from "antd";
import React, { ChangeEventHandler, useEffect, useRef, useState } from "react";
import { ICountry } from "../../helpers/types";
import { COUNTRIES } from "../../utls/CountryUtil";
import InputCompnent from "../InputComponent";
import { t } from "i18next";
import PhoneCodeComponentMini from "../PhoneCodeComponent/PhoneCodeComponentMini";

type props = {
  className?: string;
  countryCode?: string | null;
  phoneCode?: string | null;
  phone?: string | null;
  onChangePhoneCode?: (phoneCode: string, countryCode: string) => void;
  onChangePhone?: ChangeEventHandler<HTMLInputElement>;
  autoFocus?: boolean;
};

const defaultCountry: ICountry = {
  name: "France",
  dial_code: "+33",
  code: "FR",
  flag: "https://cdn.jsdelivr.net/npm/react-flagkit@1.0.2/img/SVG/FR.svg",
};

const PhoneInputComponent: React.FC<props> = ({ className, countryCode, phoneCode, phone, onChangePhoneCode, onChangePhone, autoFocus = false }) => {
  const [selectedCountry, setSelectedCountry] = useState<{
    value: string;
    country: string;
    label: React.ReactNode;
  }>({
    value: defaultCountry.dial_code,
    country: defaultCountry.code,
    label: <PhoneCodeComponentMini flag={defaultCountry.flag} dialCode={defaultCountry.dial_code} />,
  });
  const phoneInputRef = useRef<InputRef | null>(null);

  useEffect(() => {
    if (!selectedCountry || !onChangePhoneCode) return;
    setTimeout(() => {
      onChangePhoneCode?.(selectedCountry.value, selectedCountry.country);
    }, 0);
  }, []);

  useEffect(() => {
    if (autoFocus && phoneInputRef.current) {
      phoneInputRef.current.focus();
    }
  }, [autoFocus]);

  const handleChange = (country: ICountry) => {
    if (country.code !== selectedCountry?.country) {
      onChangePhoneCode?.(country.dial_code, country.code);
      setSelectedCountry({
        value: country.dial_code,
        country: country.code,
        label: <PhoneCodeComponentMini flag={country?.flag} dialCode={country?.dial_code} />,
      });
    }
  };
  return (
    <div className={`phoneCodeInput d-flex items-center w-full gap-7 ${className}`}>
      <Space>
        <Select
          className={"authPhoneDesign"}
          style={{ width: "100px", borderRadius: "5px" }}
          showSearch={false}
          suffixIcon={null}
          optionFilterProp="label"
          value={selectedCountry}
          popupClassName="phone-popup"
          listHeight={1000}
          onSelect={(option: any) => {
            const country = COUNTRIES.find((c) => c.dial_code === option.split("|")[1]);
            if (country) handleChange(country);
          }}
        >
          {COUNTRIES.map((country) => (
            <Select.Option key={country.code} value={`${country.code}|${country.dial_code}`} label={`${country.name} ${country.dial_code}`}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <PhoneCodeComponentMini flag={country?.flag} dialCode={country?.dial_code} name={country.name} />
              </div>
            </Select.Option>
          ))}
        </Select>
      </Space>

      <InputCompnent
        ref={phoneInputRef}
        className={
          className === "authDark"
            ? "authPhoneDesign"
            : className === "dark"
              ? "darkInput"
              : className === "fan-phone-modal"
                ? "fan-phone-modal-input"
                : ""
        }
        placeholder={t("number")!}
        type="tel"
        value={phone || ""}
        onChange={onChangePhone}
      />
    </div>
  );
};

export default PhoneInputComponent;
